import React, { useState, useImperativeHandle, forwardRef } from 'react'
import { Button } from '@material-ui/core'
import { useAuthDataContext } from '../../../../__providers/AuthProvider'
import Api from '../../../../__helpers/api'

//images
import mainImage from '../../../../assets/images/modals/messages/just-confirmed/icons/main.png'
import closeIcon from '../../../../assets/images/modals/messages/feedback/icons/close.png'
import leftGuyImage from '../../../../assets/images/modals/messages/just-confirmed/left-guy.png'
import rightGuyImage from '../../../../assets/images/modals/messages/just-confirmed/right-guy.png'

//actions
import { refreshNotification } from '../../../../__actions/notifications'
import { handleModal } from '../../../../__actions/globalModals'

//dispatcher
import { useDispatch, useSelector } from 'react-redux'

function JustConfirmed(props, ref) {
    const auth = useAuthDataContext()
    const dispatch = useDispatch()

    //
    const __data = useSelector(state => state)
    //
    const data = __data?.globalModalsReducer?.JUST_CONFIRMED?.data || {}

    const [state, setState] = useState({
        blur: false,
        popup: false,
    })

    useImperativeHandle(ref, () => ({
        open: () => handleOpen(),
        close: () => handleClose()
    }))

    const handleOpen = () => {
        setState(state => ({
            ...state,
            blur: true,
        }))

        setTimeout(() => {
            setState(state => ({
                ...state,
                popup: true
            }))
        }, 50)
    }

    const handleClose = () => {
        dispatch(handleModal('JUST_CONFIRMED', false, {}))

        document.querySelector('body').style.overflow = 'initial'
        document.querySelector('html').style.overflow = 'initial'

        Api.post('notifications/mark-as-read', {
            id: data?.id
        })
            .then(() => {
                dispatch(refreshNotification())
            })

        setState(state => ({
            ...state,
            popup: false
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                blur: false,
            }))
        }, 100)
    }


    return (
        <div id="overlay" className={`scrollable-mobile ${state.blur ? 'visible' : ''}`}>

            <div className={`box just-confirmed-modal ${state.popup ? 'show' : ''}`}>
                <img src={closeIcon} className="close" onClick={handleClose} />
                <img src={mainImage} className="main" />
                <h2>
                    {auth.user.activated ?
                        <>
                            Профилът ти е свързан с
                            <br />
                            учебен център {auth?.user?.center?.name}
                        </>
                        :
                        'Твоята автошкола ти отключи цялата Тема 1'
                    }

                </h2>
                <p>
                    {auth.user.activated ?
                        `${auth?.user?.name}, вашите профили вече са свързани. Твоят преподавател ще е винаги насреща и лесно ще дава насоки при нужда.`
                        :
                        `${auth?.user?.name}, учебен център „${auth?.user?.center?.name}“, ти прави жест като ти отключи както цялото съдържане на тема 1, така и изпитните въпроси към темата.`
                    }
                </p>
                <ul>
                    <li>
                        <span>
                            <img src={leftGuyImage} />
                        </span>
                        Не се притеснявай да зададеш своя въпрос под видео лекциите и той ще ти отговори.
                    </li>
                    <li>
                        <span>
                            <img src={rightGuyImage} />
                        </span>
                        Твоят преподавател по теория може да следи развитието ти и да ти помага при нужда.
                    </li>

                </ul>
                <Button onClick={handleClose} className="primary">
                    Супер!
                </Button>
            </div>
        </div >
    )
}

export default forwardRef(JustConfirmed)